<template>
    <el-card>
			<el-row :gutter="20">
				<el-col :span="6">
					<div>
						今日交易量{{items.dayCount}}
					</div>
					<!-- <div>
						
						<el-statistic title="今日交易量">
							<template slot="formatter">
								{{monthWriterMoney}}
							</template>
						</el-statistic>
					</div> -->
				</el-col>
				<el-col :span="6">
					<div>
						今日交易金额{{items.dayMoney}}
						</div>
					<!-- <div>
						<el-statistic title="今日交易金额">
							<template slot="formatter">
								{{allWriterMoney}}
							</template>
						</el-statistic>
					</div> -->
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="6">
						<div>
							本月交易量：{{items.montyCount}}
						</div>
				</el-col>
				<el-col :span="6">
						<div>
							本月交易金额{{items.montyMoney}}
						</div>
				</el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="6">
						<div>
							交易总量：{{items.allCount}}
						</div>
				</el-col>
				<el-col :span="6">
						<div>
							交易总金额{{items.allMoney}}
						</div>
				</el-col>
			</el-row>
		</el-card>
</template>


<script>
	export default{
		props: {
        //     monthWriterMoney: {
		//     type: Number,
		//     default: 0
		//   },
		//   allWriterMoney: {
		//     type: Number,
		//     default: 0
		//   },
		items: Array
		},
	}
</script>